/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccountId,
  AdminSchedulingLink,
  AppliedCrmSettingsView,
  ApplyToAllView,
  ArrayAdminSchedulingLink,
  ArrayGroupSchedulingLink,
  ArrayOwnershipSchedulingLink,
  ArrayRoundRobinSchedulingLink,
  BatchUpdateRequest,
  BookerControls,
  BookerControlsUpdateRequest,
  CreateRequest,
  CreateRequest1,
  CreateRequest2,
  CreateRequest3,
  CreateSchedulingDraftRequest,
  CreateSchedulingPublishedRequest,
  DefaultSchedulingLink1,
  GroupSchedulingLink,
  MapString,
  MapUserIdSetUserControlsResult,
  OneClickInitializationRequest,
  OneClickInitializationResponse,
  OneClickScheduleRequest,
  OneClickScheduleResponse,
  OptionApplyToAllView,
  OptionPersonalLinksCrmSettingsView,
  OwnershipRoutingRequest,
  OwnershipRoutingResponse,
  OwnershipSchedulingLink,
  PaginatedResultSchedulingView,
  PersonalLinksCrmSettingsView,
  PublicAdminSchedulingLink,
  PublicWorkspaceSettings,
  RequiresLicenseListAdminSchedulingLink,
  RequiresLicensePublicResult,
  RequiresLicenseSetGroupSchedulingLink,
  RequiresLicenseSetOwnershipSchedulingLink,
  RequiresLicenseSetRoundRobinSchedulingLink,
  RequiresLicenseUserControls,
  RoundRobinSchedulingLink,
  ScheduleMeetingRequest,
  ScheduleMeetingResponse,
  SchedulingDraftView,
  SchedulingLinkPasswordValidation,
  SchedulingPublishedView,
  SetDefaultSchedulingLink,
  SetRequiresLicenseUserControls,
  SetUserControlsResult,
  UpdateRequest,
  UpdateRequest1,
  UpdateRequest2,
  UpdateRequest3,
  UpdateRequest4,
  UpdateRequest5,
  UpdateSchedulingDraftRequest,
  UpdateSchedulingPublishedRequest,
  UpsertApplyToAllRequest,
  UpsertPersonalLinksCrmSettingsRequest,
  WorkspaceSettings,
  WorkspaceSettingsUpdateRequest,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "team-scheduling";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * No description
   *
   * @name GetSchedulings
   * @request GET:/v1/tenant/{tenantId}/schedulings
   * @secure
   */
  getSchedulings = (
    tenantId: string,
    query?: {
      /** @example "QA" */
      name?: string;
      /**
       * @pattern [^\s\\/]+
       * @example "a5sd43a5d4a3da5d5ad45ad4asd"
       */
      workspaceId?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSchedulingView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/schedulings`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSchedulings */
  getSchedulingsPathGetter = (
    tenantId: string,
    query?: {
      /** @example "QA" */
      name?: string;
      /**
       * @pattern [^\s\\/]+
       * @example "a5sd43a5d4a3da5d5ad45ad4asd"
       */
      workspaceId?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/schedulings`, query);

  /**
   * No description
   *
   * @tags scheduling-published
   * @name GetSchedulingPublished
   * @request GET:/v1/tenant/{tenantId}/scheduling/published/{schedulingId}
   * @secure
   */
  getSchedulingPublished = (tenantId: string, schedulingId: string, params: RequestParams = {}) =>
    this.request<
      SchedulingPublishedView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/scheduling/published/${schedulingId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSchedulingPublished */
  getSchedulingPublishedPathGetter = (tenantId: string, schedulingId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/scheduling/published/${schedulingId}`);

  /**
   * No description
   *
   * @tags scheduling-published
   * @name UpdateSchedulingPublished
   * @request PUT:/v1/tenant/{tenantId}/scheduling/published/{schedulingId}
   * @secure
   */
  updateSchedulingPublished = (
    tenantId: string,
    schedulingId: string,
    data: UpdateSchedulingPublishedRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SchedulingPublishedView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/scheduling/published/${schedulingId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateSchedulingPublished */
  updateSchedulingPublishedPathGetter = (tenantId: string, schedulingId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/scheduling/published/${schedulingId}`);

  /**
   * No description
   *
   * @tags scheduling-published
   * @name CreateSchedulingPublished
   * @request POST:/v1/tenant/{tenantId}/scheduling/published/{schedulingId}
   * @secure
   */
  createSchedulingPublished = (
    tenantId: string,
    schedulingId: string,
    data: CreateSchedulingPublishedRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SchedulingPublishedView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/scheduling/published/${schedulingId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSchedulingPublished */
  createSchedulingPublishedPathGetter = (tenantId: string, schedulingId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/scheduling/published/${schedulingId}`);

  /**
   * No description
   *
   * @tags scheduling-published
   * @name DeleteSchedulingPublished
   * @request DELETE:/v1/tenant/{tenantId}/scheduling/published/{schedulingId}
   * @secure
   */
  deleteSchedulingPublished = (tenantId: string, schedulingId: string, params: RequestParams = {}) =>
    this.request<
      SchedulingPublishedView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/scheduling/published/${schedulingId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteSchedulingPublished */
  deleteSchedulingPublishedPathGetter = (tenantId: string, schedulingId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/scheduling/published/${schedulingId}`);

  /**
   * No description
   *
   * @tags scheduling-draft
   * @name GetSchedulingDraft
   * @request GET:/v1/tenant/{tenantId}/scheduling/draft/{schedulingId}
   * @secure
   */
  getSchedulingDraft = (tenantId: string, schedulingId: string, params: RequestParams = {}) =>
    this.request<
      SchedulingDraftView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/scheduling/draft/${schedulingId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSchedulingDraft */
  getSchedulingDraftPathGetter = (tenantId: string, schedulingId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/scheduling/draft/${schedulingId}`);

  /**
   * No description
   *
   * @tags scheduling-draft
   * @name UpdateSchedulingDraft
   * @request PUT:/v1/tenant/{tenantId}/scheduling/draft/{schedulingId}
   * @secure
   */
  updateSchedulingDraft = (
    tenantId: string,
    schedulingId: string,
    data: UpdateSchedulingDraftRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SchedulingDraftView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/scheduling/draft/${schedulingId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateSchedulingDraft */
  updateSchedulingDraftPathGetter = (tenantId: string, schedulingId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/scheduling/draft/${schedulingId}`);

  /**
   * No description
   *
   * @tags scheduling-draft
   * @name DeleteSchedulingDraft
   * @request DELETE:/v1/tenant/{tenantId}/scheduling/draft/{schedulingId}
   * @secure
   */
  deleteSchedulingDraft = (tenantId: string, schedulingId: string, params: RequestParams = {}) =>
    this.request<
      SchedulingDraftView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/scheduling/draft/${schedulingId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteSchedulingDraft */
  deleteSchedulingDraftPathGetter = (tenantId: string, schedulingId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/scheduling/draft/${schedulingId}`);

  /**
   * No description
   *
   * @tags scheduling-draft
   * @name CreateSchedulingDraft
   * @request POST:/v1/tenant/{tenantId}/scheduling/draft
   * @secure
   */
  createSchedulingDraft = (tenantId: string, data: CreateSchedulingDraftRequest, params: RequestParams = {}) =>
    this.request<
      SchedulingDraftView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/scheduling/draft`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSchedulingDraft */
  createSchedulingDraftPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/scheduling/draft`);

  /**
   * No description
   *
   * @name FindAdminSchedulingLinksByWorkspaceId
   * @request GET:/v1/tenant/{tenantId}/admin-scheduling-links/find-by-workspace-id
   * @secure
   */
  findAdminSchedulingLinksByWorkspaceId = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayAdminSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/admin-scheduling-links/find-by-workspace-id`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAdminSchedulingLinksByWorkspaceId */
  findAdminSchedulingLinksByWorkspaceIdPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/admin-scheduling-links/find-by-workspace-id`, query);

  /**
   * No description
   *
   * @name FindAAdminSchedulingLinkBySlug
   * @request GET:/v1/guest-external/tenant/{tenantId}/admin-scheduling-links/find-by-slug/{slug}
   * @secure
   */
  findAAdminSchedulingLinkBySlug = (
    tenantId: string,
    slug: string,
    query: {
      /** @pattern [^\s\\/]+ */
      hostId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PublicAdminSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/admin-scheduling-links/find-by-slug/${slug}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAAdminSchedulingLinkBySlug */
  findAAdminSchedulingLinkBySlugPathGetter = (
    tenantId: string,
    slug: string,
    query: {
      /** @pattern [^\s\\/]+ */
      hostId: string;
    },
  ) => this.getServicePath(`/v1/guest-external/tenant/${tenantId}/admin-scheduling-links/find-by-slug/${slug}`, query);

  /**
   * No description
   *
   * @name FindAdminSchedulingLinksByUserId
   * @request GET:/v1/tenant/{tenantId}/admin-scheduling-links/find-by-user-id
   * @secure
   */
  findAdminSchedulingLinksByUserId = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      RequiresLicenseListAdminSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/admin-scheduling-links/find-by-user-id`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAdminSchedulingLinksByUserId */
  findAdminSchedulingLinksByUserIdPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/admin-scheduling-links/find-by-user-id`, query);

  /**
   * No description
   *
   * @name FindAAdminSchedulingLinkByAdminSchedulingLinkId
   * @request GET:/v1/tenant/{tenantId}/admin-scheduling-links/{adminSchedulingLinkId}
   * @secure
   */
  findAAdminSchedulingLinkByAdminSchedulingLinkId = (
    tenantId: string,
    adminSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/admin-scheduling-links/${adminSchedulingLinkId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAAdminSchedulingLinkByAdminSchedulingLinkId */
  findAAdminSchedulingLinkByAdminSchedulingLinkIdPathGetter = (tenantId: string, adminSchedulingLinkId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/admin-scheduling-links/${adminSchedulingLinkId}`);

  /**
   * No description
   *
   * @name UpdateAAdminSchedulingLink
   * @request PUT:/v1/tenant/{tenantId}/admin-scheduling-links/{adminSchedulingLinkId}
   * @secure
   */
  updateAAdminSchedulingLink = (
    tenantId: string,
    adminSchedulingLinkId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
    data: UpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/admin-scheduling-links/${adminSchedulingLinkId}`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateAAdminSchedulingLink */
  updateAAdminSchedulingLinkPathGetter = (
    tenantId: string,
    adminSchedulingLinkId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/admin-scheduling-links/${adminSchedulingLinkId}`, query);

  /**
   * No description
   *
   * @name DeleteAAdminSchedulingLink
   * @request DELETE:/v1/tenant/{tenantId}/admin-scheduling-links/{adminSchedulingLinkId}
   * @secure
   */
  deleteAAdminSchedulingLink = (tenantId: string, adminSchedulingLinkId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/admin-scheduling-links/${adminSchedulingLinkId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteAAdminSchedulingLink */
  deleteAAdminSchedulingLinkPathGetter = (tenantId: string, adminSchedulingLinkId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/admin-scheduling-links/${adminSchedulingLinkId}`);

  /**
   * No description
   *
   * @name FindAAdminSchedulingLinkByAdminSchedulingLinkIdPublic
   * @request GET:/v1/guest-external/tenant/{tenantId}/admin-scheduling-links/{adminSchedulingLinkId}
   * @secure
   */
  findAAdminSchedulingLinkByAdminSchedulingLinkIdPublic = (
    tenantId: string,
    adminSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      PublicAdminSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/admin-scheduling-links/${adminSchedulingLinkId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAAdminSchedulingLinkByAdminSchedulingLinkIdPublic */
  findAAdminSchedulingLinkByAdminSchedulingLinkIdPublicPathGetter = (tenantId: string, adminSchedulingLinkId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/admin-scheduling-links/${adminSchedulingLinkId}`);

  /**
   * No description
   *
   * @name CreateANewAdminSchedulingLink
   * @request POST:/v1/tenant/{tenantId}/admin-scheduling-links
   * @secure
   */
  createANewAdminSchedulingLink = (tenantId: string, data: CreateRequest, params: RequestParams = {}) =>
    this.request<
      AdminSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/admin-scheduling-links`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createANewAdminSchedulingLink */
  createANewAdminSchedulingLinkPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/admin-scheduling-links`);

  /**
   * @description Returns a validation result
   *
   * @name ValidatesASchedulingLinkPassword
   * @request POST:/v1/guest-external/tenant/{tenantId}/admin-scheduling-links/{adminSchedulingLinkId}/validate-password
   * @secure
   */
  validatesASchedulingLinkPassword = (
    tenantId: string,
    adminSchedulingLinkId: string,
    query: {
      /** @minLength 1 */
      password: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SchedulingLinkPasswordValidation,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/admin-scheduling-links/${adminSchedulingLinkId}/validate-password`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for validatesASchedulingLinkPassword */
  validatesASchedulingLinkPasswordPathGetter = (
    tenantId: string,
    adminSchedulingLinkId: string,
    query: {
      /** @minLength 1 */
      password: string;
    },
  ) =>
    this.getServicePath(
      `/v1/guest-external/tenant/${tenantId}/admin-scheduling-links/${adminSchedulingLinkId}/validate-password`,
      query,
    );

  /**
   * No description
   *
   * @name FindRoundRobinSchedulingLinksByWorkspaceId
   * @request GET:/v1/tenant/{tenantId}/round-robin-scheduling-links/find-by-workspace-id
   * @secure
   */
  findRoundRobinSchedulingLinksByWorkspaceId = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayRoundRobinSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/round-robin-scheduling-links/find-by-workspace-id`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findRoundRobinSchedulingLinksByWorkspaceId */
  findRoundRobinSchedulingLinksByWorkspaceIdPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/round-robin-scheduling-links/find-by-workspace-id`, query);

  /**
   * No description
   *
   * @name FindARoundRobinSchedulingLinkBySlug
   * @request GET:/v1/guest-external/tenant/{tenantId}/round-robin-scheduling-links/find-by-slug/{slug}
   * @secure
   */
  findARoundRobinSchedulingLinkBySlug = (tenantId: string, slug: string, params: RequestParams = {}) =>
    this.request<
      RoundRobinSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/round-robin-scheduling-links/find-by-slug/${slug}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findARoundRobinSchedulingLinkBySlug */
  findARoundRobinSchedulingLinkBySlugPathGetter = (tenantId: string, slug: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/round-robin-scheduling-links/find-by-slug/${slug}`);

  /**
   * No description
   *
   * @name FindRoundRobinSchedulingLinksByUserId
   * @request GET:/v1/tenant/{tenantId}/round-robin-scheduling-links/find-by-user-id
   * @secure
   */
  findRoundRobinSchedulingLinksByUserId = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      RequiresLicenseSetRoundRobinSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/round-robin-scheduling-links/find-by-user-id`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findRoundRobinSchedulingLinksByUserId */
  findRoundRobinSchedulingLinksByUserIdPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/round-robin-scheduling-links/find-by-user-id`, query);

  /**
   * No description
   *
   * @name FindARoundRobinSchedulingLinkByRoundRobinSchedulingLinkId
   * @request GET:/v1/tenant/{tenantId}/round-robin-scheduling-links/{roundRobinSchedulingLinkId}
   * @secure
   */
  findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkId = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      RoundRobinSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkId */
  findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdPathGetter = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`);

  /**
   * No description
   *
   * @name UpdateARoundRobinSchedulingLink
   * @request PUT:/v1/tenant/{tenantId}/round-robin-scheduling-links/{roundRobinSchedulingLinkId}
   * @secure
   */
  updateARoundRobinSchedulingLink = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
    data: UpdateRequest1,
    params: RequestParams = {},
  ) =>
    this.request<
      RoundRobinSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateARoundRobinSchedulingLink */
  updateARoundRobinSchedulingLinkPathGetter = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`, query);

  /**
   * No description
   *
   * @name DeleteARoundRobinSchedulingLink
   * @request DELETE:/v1/tenant/{tenantId}/round-robin-scheduling-links/{roundRobinSchedulingLinkId}
   * @secure
   */
  deleteARoundRobinSchedulingLink = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteARoundRobinSchedulingLink */
  deleteARoundRobinSchedulingLinkPathGetter = (tenantId: string, roundRobinSchedulingLinkId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`);

  /**
   * No description
   *
   * @name FindARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdPublic
   * @request GET:/v1/guest-external/tenant/{tenantId}/round-robin-scheduling-links/{roundRobinSchedulingLinkId}
   * @secure
   */
  findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdPublic = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      RoundRobinSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdPublic */
  findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdPublicPathGetter = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
  ) =>
    this.getServicePath(
      `/v1/guest-external/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`,
    );

  /**
   * No description
   *
   * @name CreateANewRoundRobinSchedulingLink
   * @request POST:/v1/tenant/{tenantId}/round-robin-scheduling-links
   * @secure
   */
  createANewRoundRobinSchedulingLink = (tenantId: string, data: CreateRequest1, params: RequestParams = {}) =>
    this.request<
      RoundRobinSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/round-robin-scheduling-links`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createANewRoundRobinSchedulingLink */
  createANewRoundRobinSchedulingLinkPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/round-robin-scheduling-links`);

  /**
   * No description
   *
   * @name FindOwnershipSchedulingLinksByWorkspaceId
   * @request GET:/v1/tenant/{tenantId}/ownership-scheduling-links/find-by-workspace-id
   * @secure
   */
  findOwnershipSchedulingLinksByWorkspaceId = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayOwnershipSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ownership-scheduling-links/find-by-workspace-id`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findOwnershipSchedulingLinksByWorkspaceId */
  findOwnershipSchedulingLinksByWorkspaceIdPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/ownership-scheduling-links/find-by-workspace-id`, query);

  /**
   * No description
   *
   * @name FindAOwnershipSchedulingLinkBySlug
   * @request GET:/v1/guest-external/tenant/{tenantId}/ownership-scheduling-links/find-by-slug/{slug}
   * @secure
   */
  findAOwnershipSchedulingLinkBySlug = (tenantId: string, slug: string, params: RequestParams = {}) =>
    this.request<
      OwnershipSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/ownership-scheduling-links/find-by-slug/${slug}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAOwnershipSchedulingLinkBySlug */
  findAOwnershipSchedulingLinkBySlugPathGetter = (tenantId: string, slug: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/ownership-scheduling-links/find-by-slug/${slug}`);

  /**
   * No description
   *
   * @name FindOwnershipSchedulingLinksByUserId
   * @request GET:/v1/tenant/{tenantId}/ownership-scheduling-links/find-by-user-id
   * @secure
   */
  findOwnershipSchedulingLinksByUserId = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      RequiresLicenseSetOwnershipSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ownership-scheduling-links/find-by-user-id`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findOwnershipSchedulingLinksByUserId */
  findOwnershipSchedulingLinksByUserIdPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/ownership-scheduling-links/find-by-user-id`, query);

  /**
   * No description
   *
   * @name FindAOwnershipSchedulingLinkByOwnershipSchedulingLinkId
   * @request GET:/v1/tenant/{tenantId}/ownership-scheduling-links/{ownershipSchedulingLinkId}
   * @secure
   */
  findAOwnershipSchedulingLinkByOwnershipSchedulingLinkId = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      OwnershipSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAOwnershipSchedulingLinkByOwnershipSchedulingLinkId */
  findAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdPathGetter = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`);

  /**
   * No description
   *
   * @name UpdateAOwnershipSchedulingLink
   * @request PUT:/v1/tenant/{tenantId}/ownership-scheduling-links/{ownershipSchedulingLinkId}
   * @secure
   */
  updateAOwnershipSchedulingLink = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
    data: UpdateRequest2,
    params: RequestParams = {},
  ) =>
    this.request<
      OwnershipSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateAOwnershipSchedulingLink */
  updateAOwnershipSchedulingLinkPathGetter = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`, query);

  /**
   * No description
   *
   * @name DeleteAOwnershipSchedulingLink
   * @request DELETE:/v1/tenant/{tenantId}/ownership-scheduling-links/{ownershipSchedulingLinkId}
   * @secure
   */
  deleteAOwnershipSchedulingLink = (tenantId: string, ownershipSchedulingLinkId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteAOwnershipSchedulingLink */
  deleteAOwnershipSchedulingLinkPathGetter = (tenantId: string, ownershipSchedulingLinkId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`);

  /**
   * No description
   *
   * @name FindAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdPublic
   * @request GET:/v1/guest-external/tenant/{tenantId}/ownership-scheduling-links/{ownershipSchedulingLinkId}
   * @secure
   */
  findAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdPublic = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      OwnershipSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdPublic */
  findAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdPublicPathGetter = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
  ) =>
    this.getServicePath(
      `/v1/guest-external/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`,
    );

  /**
   * No description
   *
   * @name CreateANewOwnershipSchedulingLink
   * @request POST:/v1/tenant/{tenantId}/ownership-scheduling-links
   * @secure
   */
  createANewOwnershipSchedulingLink = (tenantId: string, data: CreateRequest2, params: RequestParams = {}) =>
    this.request<
      OwnershipSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ownership-scheduling-links`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createANewOwnershipSchedulingLink */
  createANewOwnershipSchedulingLinkPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/ownership-scheduling-links`);

  /**
   * No description
   *
   * @name RouteGuestToAOwnershipSchedulingLink
   * @request POST:/v1/guest-external/tenant/{tenantId}/ownership-scheduling-links/{ownershipSchedulingLinkId}/route-guest
   * @secure
   */
  routeGuestToAOwnershipSchedulingLink = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
    data: OwnershipRoutingRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      OwnershipRoutingResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}/route-guest`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for routeGuestToAOwnershipSchedulingLink */
  routeGuestToAOwnershipSchedulingLinkPathGetter = (tenantId: string, ownershipSchedulingLinkId: string) =>
    this.getServicePath(
      `/v1/guest-external/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}/route-guest`,
    );

  /**
   * No description
   *
   * @name FindGroupSchedulingLinksByWorkspaceId
   * @request GET:/v1/tenant/{tenantId}/group-scheduling-links/find-by-workspace-id
   * @secure
   */
  findGroupSchedulingLinksByWorkspaceId = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayGroupSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/group-scheduling-links/find-by-workspace-id`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findGroupSchedulingLinksByWorkspaceId */
  findGroupSchedulingLinksByWorkspaceIdPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/group-scheduling-links/find-by-workspace-id`, query);

  /**
   * No description
   *
   * @name FindAGroupSchedulingLinkBySlug
   * @request GET:/v1/guest-external/tenant/{tenantId}/group-scheduling-links/find-by-slug/{slug}
   * @secure
   */
  findAGroupSchedulingLinkBySlug = (tenantId: string, slug: string, params: RequestParams = {}) =>
    this.request<
      GroupSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/group-scheduling-links/find-by-slug/${slug}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAGroupSchedulingLinkBySlug */
  findAGroupSchedulingLinkBySlugPathGetter = (tenantId: string, slug: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/group-scheduling-links/find-by-slug/${slug}`);

  /**
   * No description
   *
   * @name FindGroupSchedulingLinksByUserId
   * @request GET:/v1/tenant/{tenantId}/group-scheduling-links/find-by-user-id
   * @secure
   */
  findGroupSchedulingLinksByUserId = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      RequiresLicenseSetGroupSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/group-scheduling-links/find-by-user-id`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findGroupSchedulingLinksByUserId */
  findGroupSchedulingLinksByUserIdPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/group-scheduling-links/find-by-user-id`, query);

  /**
   * No description
   *
   * @name FindAGroupSchedulingLinkByGroupSchedulingLinkId
   * @request GET:/v1/tenant/{tenantId}/group-scheduling-links/{groupSchedulingLinkId}
   * @secure
   */
  findAGroupSchedulingLinkByGroupSchedulingLinkId = (
    tenantId: string,
    groupSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      GroupSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/group-scheduling-links/${groupSchedulingLinkId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAGroupSchedulingLinkByGroupSchedulingLinkId */
  findAGroupSchedulingLinkByGroupSchedulingLinkIdPathGetter = (tenantId: string, groupSchedulingLinkId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/group-scheduling-links/${groupSchedulingLinkId}`);

  /**
   * No description
   *
   * @name UpdateAGroupSchedulingLink
   * @request PUT:/v1/tenant/{tenantId}/group-scheduling-links/{groupSchedulingLinkId}
   * @secure
   */
  updateAGroupSchedulingLink = (
    tenantId: string,
    groupSchedulingLinkId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
    data: UpdateRequest3,
    params: RequestParams = {},
  ) =>
    this.request<
      GroupSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/group-scheduling-links/${groupSchedulingLinkId}`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateAGroupSchedulingLink */
  updateAGroupSchedulingLinkPathGetter = (
    tenantId: string,
    groupSchedulingLinkId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/group-scheduling-links/${groupSchedulingLinkId}`, query);

  /**
   * No description
   *
   * @name DeleteAGroupSchedulingLink
   * @request DELETE:/v1/tenant/{tenantId}/group-scheduling-links/{groupSchedulingLinkId}
   * @secure
   */
  deleteAGroupSchedulingLink = (tenantId: string, groupSchedulingLinkId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/group-scheduling-links/${groupSchedulingLinkId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteAGroupSchedulingLink */
  deleteAGroupSchedulingLinkPathGetter = (tenantId: string, groupSchedulingLinkId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/group-scheduling-links/${groupSchedulingLinkId}`);

  /**
   * No description
   *
   * @name FindAGroupSchedulingLinkByGroupSchedulingLinkIdPublic
   * @request GET:/v1/guest-external/tenant/{tenantId}/group-scheduling-links/{groupSchedulingLinkId}
   * @secure
   */
  findAGroupSchedulingLinkByGroupSchedulingLinkIdPublic = (
    tenantId: string,
    groupSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      GroupSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/group-scheduling-links/${groupSchedulingLinkId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAGroupSchedulingLinkByGroupSchedulingLinkIdPublic */
  findAGroupSchedulingLinkByGroupSchedulingLinkIdPublicPathGetter = (tenantId: string, groupSchedulingLinkId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/group-scheduling-links/${groupSchedulingLinkId}`);

  /**
   * No description
   *
   * @name CreateANewGroupSchedulingLink
   * @request POST:/v1/tenant/{tenantId}/group-scheduling-links
   * @secure
   */
  createANewGroupSchedulingLink = (tenantId: string, data: CreateRequest3, params: RequestParams = {}) =>
    this.request<
      GroupSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/group-scheduling-links`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createANewGroupSchedulingLink */
  createANewGroupSchedulingLinkPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/group-scheduling-links`);

  /**
   * No description
   *
   * @name FindUserControlsByMultipleUserIds
   * @request GET:/v1/tenant/{tenantId}/user-controls/find-by-user-ids
   * @secure
   */
  findUserControlsByMultipleUserIds = (
    tenantId: string,
    query?: {
      userId?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SetRequiresLicenseUserControls,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-controls/find-by-user-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUserControlsByMultipleUserIds */
  findUserControlsByMultipleUserIdsPathGetter = (
    tenantId: string,
    query?: {
      userId?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user-controls/find-by-user-ids`, query);

  /**
   * No description
   *
   * @name FindUserControlsByUserId
   * @request GET:/v1/tenant/{tenantId}/user-controls/{userId}
   * @secure
   */
  findUserControlsByUserId = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      RequiresLicenseUserControls,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-controls/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUserControlsByUserId */
  findUserControlsByUserIdPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user-controls/${userId}`);

  /**
   * No description
   *
   * @name UpdateUserControlsForAGivenUserId
   * @request PUT:/v1/tenant/{tenantId}/user-controls/{userId}
   * @secure
   */
  updateUserControlsForAGivenUserId = (
    tenantId: string,
    userId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
    data: UpdateRequest4,
    params: RequestParams = {},
  ) =>
    this.request<
      SetUserControlsResult,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-controls/${userId}`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateUserControlsForAGivenUserId */
  updateUserControlsForAGivenUserIdPathGetter = (
    tenantId: string,
    userId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user-controls/${userId}`, query);

  /**
   * No description
   *
   * @name FindUserControlsByUserIdCalledFromTheOutside
   * @request GET:/v1/guest-external/tenant/{tenantId}/user-controls/{userId}
   * @secure
   */
  findUserControlsByUserIdCalledFromTheOutside = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      RequiresLicensePublicResult,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/user-controls/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUserControlsByUserIdCalledFromTheOutside */
  findUserControlsByUserIdCalledFromTheOutsidePathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/user-controls/${userId}`);

  /**
   * No description
   *
   * @name UpdateUserControlsInABatch
   * @request PUT:/v1/tenant/{tenantId}/user-controls
   * @secure
   */
  updateUserControlsInABatch = (tenantId: string, data: BatchUpdateRequest, params: RequestParams = {}) =>
    this.request<
      MapUserIdSetUserControlsResult,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-controls`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateUserControlsInABatch */
  updateUserControlsInABatchPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user-controls`);

  /**
   * No description
   *
   * @name FindDefaultSchedulingLinkByMultipleUserIds
   * @request GET:/v1/tenant/{tenantId}/default-scheduling-link/find-by-user-ids
   * @secure
   */
  findDefaultSchedulingLinkByMultipleUserIds = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      userId: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SetDefaultSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/default-scheduling-link/find-by-user-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findDefaultSchedulingLinkByMultipleUserIds */
  findDefaultSchedulingLinkByMultipleUserIdsPathGetter = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      userId: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/default-scheduling-link/find-by-user-ids`, query);

  /**
   * No description
   *
   * @name FindDefaultSchedulingLinkByUserId
   * @request GET:/v1/tenant/{tenantId}/default-scheduling-link/{userId}
   * @secure
   */
  findDefaultSchedulingLinkByUserId = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      DefaultSchedulingLink1,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/default-scheduling-link/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findDefaultSchedulingLinkByUserId */
  findDefaultSchedulingLinkByUserIdPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/default-scheduling-link/${userId}`);

  /**
   * No description
   *
   * @name UpdateADefaultSchedulingLink
   * @request PUT:/v1/tenant/{tenantId}/default-scheduling-link/{userId}
   * @secure
   */
  updateADefaultSchedulingLink = (tenantId: string, userId: string, data: UpdateRequest5, params: RequestParams = {}) =>
    this.request<
      DefaultSchedulingLink1,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/default-scheduling-link/${userId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateADefaultSchedulingLink */
  updateADefaultSchedulingLinkPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/default-scheduling-link/${userId}`);

  /**
   * No description
   *
   * @name FindPublicDefaultSchedulingLinkByUserIdCalledFromTheOutside
   * @request GET:/v1/guest-external/tenant/{tenantId}/default-scheduling-link/{userId}
   * @secure
   */
  findPublicDefaultSchedulingLinkByUserIdCalledFromTheOutside = (
    tenantId: string,
    userId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      DefaultSchedulingLink1,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/default-scheduling-link/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findPublicDefaultSchedulingLinkByUserIdCalledFromTheOutside */
  findPublicDefaultSchedulingLinkByUserIdCalledFromTheOutsidePathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/default-scheduling-link/${userId}`);

  /**
   * @description Returns config or nothing if not set
   *
   * @tags apply-to-all-config
   * @name GetApplyToAll
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}
   * @secure
   */
  getApplyToAll = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      OptionApplyToAllView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApplyToAll */
  getApplyToAllPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}`);

  /**
   * @description Updates config or creates record from defaults if not set
   *
   * @tags apply-to-all-config
   * @name UpsertApplyToAll
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}
   * @secure
   */
  upsertApplyToAll = (
    tenantId: string,
    workspaceId: string,
    data: UpsertApplyToAllRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      ApplyToAllView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for upsertApplyToAll */
  upsertApplyToAllPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}`);

  /**
   * @description Performs deletion of db record
   *
   * @tags apply-to-all-config
   * @name Delete
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}
   * @secure
   */
  delete = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for delete */
  deletePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}`);

  /**
   * @description Returns settings or nothing if not set
   *
   * @tags personal-links-crm-settings
   * @name GetPersonalLinksCrmSettings
   * @request GET:/v1/tenant/{tenantId}/personal-links-crm-settings
   * @secure
   */
  getPersonalLinksCrmSettings = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      OptionPersonalLinksCrmSettingsView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/personal-links-crm-settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getPersonalLinksCrmSettings */
  getPersonalLinksCrmSettingsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/personal-links-crm-settings`);

  /**
   * @description Updates config or creates record from defaults if not set
   *
   * @tags personal-links-crm-settings
   * @name UpsertPersonalLinksCrmSettings
   * @request PUT:/v1/tenant/{tenantId}/personal-links-crm-settings
   * @secure
   */
  upsertPersonalLinksCrmSettings = (
    tenantId: string,
    data: UpsertPersonalLinksCrmSettingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      PersonalLinksCrmSettingsView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/personal-links-crm-settings`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for upsertPersonalLinksCrmSettings */
  upsertPersonalLinksCrmSettingsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/personal-links-crm-settings`);

  /**
   * @description Performs deletion of db record
   *
   * @tags personal-links-crm-settings
   * @name Delete2
   * @request DELETE:/v1/tenant/{tenantId}/personal-links-crm-settings
   * @originalName delete
   * @duplicate
   * @secure
   */
  delete2 = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/personal-links-crm-settings`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for delete2 */
  delete2PathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/personal-links-crm-settings`);

  /**
   * No description
   *
   * @name FindWorkspaceSettingsByWorkspaceId
   * @request GET:/v1/tenant/{tenantId}/workspace-settings/{workspaceId}
   * @secure
   */
  findWorkspaceSettingsByWorkspaceId = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      WorkspaceSettings,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace-settings/${workspaceId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findWorkspaceSettingsByWorkspaceId */
  findWorkspaceSettingsByWorkspaceIdPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace-settings/${workspaceId}`);

  /**
   * No description
   *
   * @name UpdateAWorkspaceSettings
   * @request PUT:/v1/tenant/{tenantId}/workspace-settings/{workspaceId}
   * @secure
   */
  updateAWorkspaceSettings = (
    tenantId: string,
    workspaceId: string,
    data: WorkspaceSettingsUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      WorkspaceSettings,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace-settings/${workspaceId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateAWorkspaceSettings */
  updateAWorkspaceSettingsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace-settings/${workspaceId}`);

  /**
   * No description
   *
   * @name DeleteAWorkspaceSettings
   * @request DELETE:/v1/tenant/{tenantId}/workspace-settings/{workspaceId}
   * @secure
   */
  deleteAWorkspaceSettings = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace-settings/${workspaceId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteAWorkspaceSettings */
  deleteAWorkspaceSettingsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace-settings/${workspaceId}`);

  /**
   * No description
   *
   * @name FindWorkspaceSettingsByWorkspaceId2
   * @request GET:/v1/guest-external/tenant/{tenantId}/workspace-settings/{workspaceId}
   * @originalName findWorkspaceSettingsByWorkspaceId
   * @duplicate
   * @secure
   */
  findWorkspaceSettingsByWorkspaceId2 = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      PublicWorkspaceSettings,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/workspace-settings/${workspaceId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findWorkspaceSettingsByWorkspaceId2 */
  findWorkspaceSettingsByWorkspaceId2PathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/workspace-settings/${workspaceId}`);

  /**
   * No description
   *
   * @name FindBookerControlsByWorkspaceId
   * @request GET:/v1/tenant/{tenantId}/booker-controls/{workspaceId}
   * @secure
   */
  findBookerControlsByWorkspaceId = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      BookerControls,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/booker-controls/${workspaceId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findBookerControlsByWorkspaceId */
  findBookerControlsByWorkspaceIdPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/booker-controls/${workspaceId}`);

  /**
   * No description
   *
   * @name UpdateABookerControls
   * @request PUT:/v1/tenant/{tenantId}/booker-controls/{workspaceId}
   * @secure
   */
  updateABookerControls = (
    tenantId: string,
    workspaceId: string,
    data: BookerControlsUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      BookerControls,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/booker-controls/${workspaceId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateABookerControls */
  updateABookerControlsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/booker-controls/${workspaceId}`);

  /**
   * No description
   *
   * @name DeleteABookerControls
   * @request DELETE:/v1/tenant/{tenantId}/booker-controls/{workspaceId}
   * @secure
   */
  deleteABookerControls = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/booker-controls/${workspaceId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteABookerControls */
  deleteABookerControlsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/booker-controls/${workspaceId}`);

  /**
   * @description Returns a MeetingId if the request was accepted and Error otherwise
   *
   * @name ScheduleAMeetingGuestEndpoint
   * @request POST:/v1/guest-external/tenant/{tenantId}/meeting
   * @secure
   */
  scheduleAMeetingGuestEndpoint = (tenantId: string, data: ScheduleMeetingRequest, params: RequestParams = {}) =>
    this.request<
      ScheduleMeetingResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/meeting`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for scheduleAMeetingGuestEndpoint */
  scheduleAMeetingGuestEndpointPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/meeting`);

  /**
   * @description Attempts to fill the guest form based on the data fetched from various data sources. Returns a meeting ID if the request was accepted. Returns partially filled data if the attempt failed.
   *
   * @name OneClickScheduleAMeetingGuestEndpoint
   * @request POST:/v1/guest-external/tenant/{tenantId}/meeting/one-click
   * @deprecated
   * @secure
   */
  oneClickScheduleAMeetingGuestEndpoint = (
    tenantId: string,
    data: OneClickScheduleRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      OneClickScheduleResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/meeting/one-click`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for oneClickScheduleAMeetingGuestEndpoint */
  oneClickScheduleAMeetingGuestEndpointPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/meeting/one-click`);

  /**
   * @description Initialize a guest form and resolves primary guest in one-click scheduling scenario and reports known fields.
   *
   * @name InitializeOneClickSchedulingFormGuestEndpoint
   * @request POST:/v1/guest-external/tenant/{tenantId}/meeting/one-click/initialize
   * @secure
   */
  initializeOneClickSchedulingFormGuestEndpoint = (
    tenantId: string,
    data: OneClickInitializationRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      OneClickInitializationResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/meeting/one-click/initialize`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for initializeOneClickSchedulingFormGuestEndpoint */
  initializeOneClickSchedulingFormGuestEndpointPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/meeting/one-click/initialize`);

  /**
   * @description Returns config or default if not set
   *
   * @tags crm-settings
   * @name GetAdminSchedulingLinkCrmSettings
   * @request GET:/v1/tenant/{tenantId}/admin-scheduling-links/{adminSchedulingLinkId}/crm-settings
   * @secure
   */
  getAdminSchedulingLinkCrmSettings = (tenantId: string, adminSchedulingLinkId: string, params: RequestParams = {}) =>
    this.request<
      AppliedCrmSettingsView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/admin-scheduling-links/${adminSchedulingLinkId}/crm-settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAdminSchedulingLinkCrmSettings */
  getAdminSchedulingLinkCrmSettingsPathGetter = (tenantId: string, adminSchedulingLinkId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/admin-scheduling-links/${adminSchedulingLinkId}/crm-settings`);

  /**
   * @description Returns config or default if not set
   *
   * @tags crm-settings
   * @name GetRoundRobinCrmSettings
   * @request GET:/v1/tenant/{tenantId}/round-robin-scheduling-links/{roundRobinSchedulingLinkId}/crm-settings
   * @secure
   */
  getRoundRobinCrmSettings = (tenantId: string, roundRobinSchedulingLinkId: string, params: RequestParams = {}) =>
    this.request<
      AppliedCrmSettingsView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}/crm-settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getRoundRobinCrmSettings */
  getRoundRobinCrmSettingsPathGetter = (tenantId: string, roundRobinSchedulingLinkId: string) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}/crm-settings`,
    );

  /**
   * @description Returns config or default if not set
   *
   * @tags crm-settings
   * @name GetOwnershipCrmSettings
   * @request GET:/v1/tenant/{tenantId}/ownership-scheduling-links/{ownershipSchedulingLinkId}/crm-settings
   * @secure
   */
  getOwnershipCrmSettings = (tenantId: string, ownershipSchedulingLinkId: string, params: RequestParams = {}) =>
    this.request<
      AppliedCrmSettingsView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}/crm-settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getOwnershipCrmSettings */
  getOwnershipCrmSettingsPathGetter = (tenantId: string, ownershipSchedulingLinkId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}/crm-settings`);

  /**
   * @description Returns config or default if not set
   *
   * @tags crm-settings
   * @name GetGroupSchedulingLinkCrmSettings
   * @request GET:/v1/tenant/{tenantId}/group-scheduling-links/{groupSchedulingLinkId}/crm-settings
   * @secure
   */
  getGroupSchedulingLinkCrmSettings = (tenantId: string, groupSchedulingLinkId: string, params: RequestParams = {}) =>
    this.request<
      AppliedCrmSettingsView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/group-scheduling-links/${groupSchedulingLinkId}/crm-settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getGroupSchedulingLinkCrmSettings */
  getGroupSchedulingLinkCrmSettingsPathGetter = (tenantId: string, groupSchedulingLinkId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/group-scheduling-links/${groupSchedulingLinkId}/crm-settings`);

  /**
   * @description Returns config or default if not set
   *
   * @tags crm-settings
   * @name GetPersonalSchedulingLinkCrmSettings
   * @request GET:/v1/tenant/{tenantId}/personal-scheduling-links/{meetingTypeId}/crm-settings
   * @secure
   */
  getPersonalSchedulingLinkCrmSettings = (tenantId: string, meetingTypeId: string, params: RequestParams = {}) =>
    this.request<
      AppliedCrmSettingsView,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/personal-scheduling-links/${meetingTypeId}/crm-settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getPersonalSchedulingLinkCrmSettings */
  getPersonalSchedulingLinkCrmSettingsPathGetter = (tenantId: string, meetingTypeId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/personal-scheduling-links/${meetingTypeId}/crm-settings`);
}
